import { merchantInfoUrl } from "../api/endpoints.js";
import getFetchWrapper from "../api/getFetchWrapper.js";
const queryFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      merchantId: keyProps.merchantId
    });
    return fetchWrapper(`${merchantInfoUrl}?${params}`, {
      method: "GET"
    });
  };
};
export { queryFnFactory as default };
//# sourceMappingURL=query.js.map
